import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap5";

export default class extends Controller {
  static values = { term: String, prices: Array };
  static targets = ["price", "price_copy"];

  modalShowHandler(event) {
    // Button that triggered the modal
    //console.log(event);
    const button = event.relatedTarget.target;

    if (button) {
      // Extract info from data-bs-* attributes
      const title = button.getAttribute("data-modal-title");
      $(event.target).find(".modal-title").html(title);
      const plan_copy = button.getAttribute(
        this.termValue == "year" ? "data-annual-plan-copy" : "data-plan-copy"
      );
      const package_name = button.getAttribute("data-plans-name-param");
      //console.log("this.termValue:", this.termValue, "copy:", plan_copy,"name:", package_name, );
      $(event.target)
        .find(".modal-plan-submit")
        .attr("data-plans-name-param", package_name);
      $(event.target).find(".modal-plan-copy").html(plan_copy);
    }
  }

  initialize() {
    this.boundModalShowHandler = this.modalShowHandler.bind(this);
  }

  connect() {
    this.updatePrices();
    const apm = document.querySelector("#annualPlanModal");
    this.modal = new Modal(apm);

    console.log("connect", this.termValue);
    $(".modal").on("show.bs.modal", this.boundModalShowHandler);
  }

  disconnect() {
    $(".modal").off("show.bs.modal", this.boundModalShowHandler);
  }

  updatePrices() {
    this.priceTargets.forEach((e, i) => {
      console.log(this.pricesValue, e, i);
      e.innerHTML =
        this.pricesValue[i][
          this.termValue == "year" ? "annual_monthly_price" : "price"
        ];
    });
  }

  termValueChanged() {
    this.updatePrices();
    this.manageAlert();
  }

  manageAlert() {
    if (this.termValue == "year") {
      $("#discount_alert").slideUp();
    } else {
      $("#discount_alert").slideDown();
    }
  }

  switch(event) {
    console.log(event);
    this.termValue = event.target.value;
  }

  startPlan(event) {
    console.log(this.termValue, event.params.name);
    document.querySelector("input[name='plan[package_name]'").value =
      event.params.name;
    document.querySelector("input[name='plan[term]']").value = this.termValue;

    document.querySelector("#plan_form").requestSubmit();
  }

  nav(event) {
    if (
      this.modal &&
      document.querySelector("#annualPlanModal #modal_default_payment_method")
    ) {
      this.modal.show(event);
    } else {
      Turbo.visit(
        `${event.params.url}?plan=${event.params.name}&term=${this.termValue}`
      );
    }
  }
}
